export default __webpack_public_path__ + "static/media/camo.eebdd69f7f66695f704aba4e212bcdab.svg";